module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_primaerlogo_postale_pos.2b020da7.svg";